import {MarginQuizQuestionController} from "./MarginQuizQuestionController";
import {BULL_CALL} from "../MarginQuizQuestions";

export const BullCallSpread = "tfBullCallSpreadQuestion";

export function bullCallSpread() {
    return {
        templateUrl: "app/quiz/margin/questions/BullCallSpreadPayoff.html",
        bindings: {
            previousAnswers: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: BullCallSpreadPayoffController
    };
}

export class BullCallSpreadPayoffController extends MarginQuizQuestionController {
    public config = BULL_CALL;
}
